import { render, staticRenderFns } from "./orderTime.vue?vue&type=template&id=4713be64&scoped=true&"
import script from "./orderTime.vue?vue&type=script&lang=js&"
export * from "./orderTime.vue?vue&type=script&lang=js&"
import style0 from "./orderTime.vue?vue&type=style&index=0&id=4713be64&prod&lang=less&scoped=true&"
import style1 from "./orderTime.vue?vue&type=style&index=1&id=4713be64&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4713be64",
  null
  
)

export default component.exports